<template>
    <div class="Alert" v-if="show">
        <div class="mask"></div>
        <div class="popContent">
            <div class="closeIcon hide" @click="close" v-if="closeBtn"></div>
            <div class="panels">
                <div class="title">{{title}}</div>
                <div class="content">
                    <div class="description" :style="{textAlign: align || 'left'}" v-html="text"></div>
                    <div class="buttonArea">
                        <span class="btns flex1" @click="clear">{{clearText}}</span>
                        <span class="btns flex1 red" @click="confirm">{{confirmText}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Index from './index.js';
    export default Index;
</script>

<style lang="less">
    @import './index.less';
</style>



// WEBPACK FOOTER //
// src/ui/confirm/index.vue